<template>
  <div class="flex items-center justify-center w-full h-screen bg-img vx-row no-gutter">
    <div class="m-0 vx-col">
      <vx-card>
        <div slot="no-body">
          <div class="items-center justify-center vx-row no-gutter">
            <div class="vx-col d-theme-dark-bg">
              <section>
                <div class="container max-w-full px-6 py-24 mx-auto">
                  <h1
                    class="text-4xl font-medium leading-snug tracking-wider text-center text-black"
                  >The right price for you, whoever you are</h1>
                  <vs-alert
                    class="px-6 mt-6 text-lg text-center text-gray-700"
                    color="primary"
                    v-if="packages.filter(p => p.monthlyCost === 0).length > 0"
                  >{{packages.filter(p => p.monthlyCost === 0)[0].title}} package will be automatically activated after registration.</vs-alert>

                  <div class="w-48 h-1 mx-auto mt-4 bg-gray-400 rounded opacity-75">
                    <div class="flex items-center justify-center w-full vx-row no-gutter">
                      <div v-on:click="selected = 'm'">
                        <vs-chip
                          :color="selected === 'm' ? 'success' : 'dark'"
                          class="mt-3"
                          style="cursor: pointer"
                        >Monthly</vs-chip>
                      </div>
                      <div v-on:click="selected = 'y'">
                        <vs-chip
                          :color="selected === 'y' ? 'success' : 'dark'"
                          class="mt-3"
                          style="cursor: pointer"
                        >Yearly</vs-chip>
                      </div>
                    </div>
                  </div>

                  <div class="max-w-full mx-auto my-3 mt-10 md:max-w-6xl md:px-8">
                    <div
                      class="relative flex flex-col items-center block space-x-3 md:flex-row space-between"
                      style="align-items: flex-start !important;"
                    >
                      <div
                        class="relative z-0 w-11/12 max-w-sm my-8 rounded-lg shadow-lg sm:w-3/5 lg:w-1/3 sm:my-5 md:-ml-4"
                        v-for="(p, index) in packages"
                        :key="index"
                      >
                        <div
                          class="overflow-hidden text-black bg-white rounded-lg shadow-lg shadow-inner"
                        >
                          <div
                            class="block max-w-sm px-8 mx-auto mt-2 text-sm text-left text-black sm:text-md lg:px-6"
                          >
                            <h1
                              class="p-3 pb-0 text-lg font-medium tracking-wide text-center capitalize"
                            >{{p.title}}</h1>
                            <h2
                              class="pb-6 mt-4 text-sm text-center text-gray-900"
                              v-if="selected === 'm'"
                            >
                              <span class="text-2xl">${{p.monthlyCost}}</span> /mo
                            </h2>
                            <h2
                              class="pb-6 mt-4 text-sm text-center text-gray-900"
                              v-if="selected === 'y'"
                            >
                              <span class="text-xl">
                                <span
                                  class="line-through text-danger"
                                  v-if="p.monthlyCost > 0 && (p.yearlyCost < p.monthlyCost * 12)"
                                >${{p.monthlyCost * 12 }}</span>
                                ${{p.yearlyCost}}
                              </span> /year
                            </h2>
                          </div>
                          <div class="flex flex-wrap px-6 mt-3">
                            <ul>
                              <li class="flex items-center">
                                <div class="p-2 text-green-700 rounded-full fill-current">
                                  <div
                                    class="block mx-auto text-center"
                                    style="height: 32px; width: 32px;"
                                  >
                                    <img
                                      :src="require('@/assets/images/svg/simulation.svg')"
                                      style="width:100%; height:100%; object-fit: contain"
                                    />
                                  </div>
                                </div>
                                <span
                                  class="ml-3 text-gray-700 text-m"
                                >{{p.simulationCount === -1 ? 'Unlimited' : selected === 'm' ? p.simulationCount : p.simulationCount * 12}} simulations</span>
                              </li>
                              <li class="flex items-center">
                                <div class="p-2 text-green-700 rounded-full fill-current">
                                  <div
                                    class="block mx-auto text-center"
                                    style="height: 32px; width: 32px;"
                                  >
                                    <img
                                      :src="require('@/assets/images/mitre.png')"
                                      style="width:100%; height:100%; object-fit: contain"
                                    />
                                  </div>
                                </div>
                                <span
                                  class="ml-3 text-gray-700 text-m"
                                >{{p.mitreSize === -1 ? 'Unlimited' : p.mitreSize}} Mitre Att&ck techniques per simulation</span>
                              </li>
                              <li class="flex items-center">
                                <div class="p-2 text-green-700 rounded-full fill-current">
                                  <div
                                    class="block mx-auto text-center"
                                    style="height: 32px; width: 32px;"
                                  >
                                    <img
                                      :src="require('@/assets/images/svg/calendar.svg')"
                                      style="width:100%; height:100%; object-fit: contain"
                                    />
                                  </div>
                                </div>
                                <span
                                  class="ml-3 text-gray-700 text-m"
                                >Simulations accessible for {{p.validFor === -1 ? 'license time' : `${p.validFor} ${p.validFor > 1 ? 'days' : 'day'}`}}</span>
                              </li>
                              <li class="flex items-center" v-if="p.blueTeam">
                                <div class="p-2 text-green-700 rounded-full fill-current">
                                  <div
                                    class="block mx-auto text-center"
                                    style="height: 32px; width: 32px;"
                                  >
                                    <img
                                      :src="require('@/assets/images/svg/blue-team.svg')"
                                      style="width:100%; height:100%; object-fit: contain"
                                    />
                                  </div>
                                </div>
                                <span class="ml-3 text-gray-700 text-m">Blue Team Module</span>
                              </li>
                              <li class="flex items-center" v-if="p.technicalSupport">
                                <div class="p-2 text-green-700 rounded-full fill-current">
                                  <div
                                    class="block mx-auto text-center"
                                    style="height: 32px; width: 32px;"
                                  >
                                    <img
                                      :src="require('@/assets/images/svg/support.svg')"
                                      style="width:100%; height:100%; object-fit: contain"
                                    />
                                  </div>
                                </div>
                                <span class="ml-3 text-gray-700 text-m">24/7 Technical Support</span>
                              </li>
                            </ul>
                          </div>

                          <div class="flex items-center block p-8 uppercase">
                            <button
                              class="block w-full px-6 py-3 mt-3 text-lg font-semibold text-white bg-black rounded-lg shadow-xl hover:bg-gray-700"
                              @click="$router.push('/register')"
                            >Register</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
        <router-link to="/login">
          <i class="mr-1 fa fa-arrow-left" style="font-size: 17px;" /> Back
        </router-link>
      </vx-card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      packages: [],
      selected: 'm'
    }
  },
  created () {
    this.$http.get('/external/packages').then((res) => {
      if (res.data.status === true) {
        this.packages = res.data.packages
      }
    })
  }
}
</script>
